/**
 * Claves i18n (misma jerarquía que en `public/i18n/es.json` y `public/i18n/en.json`).
 * Los textos se resuelven en runtime vía `WorkflowFormDefaultsService` (HTTP a `/i18n/*.json`).
 */
export const WORKFLOW_FORM_I18N_KEYS = {
	HOME_FORM_DESCRIPTION: 'WORKFLOWS.FORM.OPERATIONS.HOME_FORM_DESCRIPTION',
	FINISH_LOADING_TEXT: 'WORKFLOWS.FORM.OPERATIONS.FINISH_LOADING_TEXT_DEFAULT',
	FINISH_OK_TITLE: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.OK_TITLE_DEFAULT',
	FINISH_OK_DESCRIPTION: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.OK_DESCRIPTION_DEFAULT',
	FINISH_KO_TITLE: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.KO_TITLE_DEFAULT',
	FINISH_KO_DESCRIPTION: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.KO_DESCRIPTION_DEFAULT',
	FINISH_CANCELLED_TITLE: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.CANCELLED_TITLE_DEFAULT',
	FINISH_CANCELLED_DESCRIPTION: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.CANCELLED_DESCRIPTION_DEFAULT',
	FINISH_PENDING_TITLE: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.PENDING_TITLE_DEFAULT',
	FINISH_PENDING_DESCRIPTION: 'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.PENDING_DESCRIPTION_DEFAULT',
	GENERIC_DOC_TITLE: 'DOCS.GENERIC',
	GENERIC_DOC_DESCRIPTION: 'DOCS.GENERIC_DESCRIPTION',
	DELAYED_PROCESS_DEFAULT_WARNING_TEXT: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT',
	DOCUMENTS_SECTION_TITLE: 'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_TITLE',
} as const;

/**
 * Ruta i18n (puntos) de pautas por defecto en `public/i18n/*.json` (bloque `DOCS` o modal de documento).
 */
export const WORKFLOW_DOC_INSTRUCTIONS_I18N_PATH: Readonly<Record<string, string>> = {
	DRIVE_LICENSE: 'DOCS.DRIVE_LICENSE_INSTRUCTIONS',
	DNI: 'DOCS.DNI_INSTRUCTIONS',
	PASSPORT: 'DOCS.PASSPORT_INSTRUCTIONS',
	NIE: 'DOCS.NIE_INSTRUCTIONS',
	CERT_REG_CIU_UE: 'DOCS.CERT_REG_CIU_UE_INSTRUCTIONS',
	IRPF: 'DOCS.IRPF_INSTRUCTIONS',
	CHECK: 'DOCS.CHECK_INSTRUCTIONS',
	INVOICE: 'DOCS.INVOICE_INSTRUCTIONS',
	WORKLIFE: 'DOCS.WORKLIFE_INSTRUCTIONS',
	PAYROLL: 'DOCS.PAYROLL_INSTRUCTIONS',
	SCRIPTURE: 'DOCS.SCRIPTURE_INSTRUCTIONS',
	GENERIC: 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GUIDELINES_PLACEHOLDER',
};

/** Claves i18n por locale para el bloque de mensaje de bienvenida diferido. */
export const DELAYED_WARNING_DEFAULT_TEXT_KEY_BY_LOCALE: Record<string, string> = {
	es: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT_LOCALE_ES',
	en: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT_LOCALE_EN',
	fr: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT_LOCALE_FR',
	it: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT_LOCALE_IT',
	pt: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DEFAULT_TEXT_LOCALE_PT',
};

export const DELAYED_WARNING_PLACEHOLDER_KEY_BY_LOCALE: Record<string, string> = {
	es: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_PLACEHOLDER_LOCALE_ES',
	en: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_PLACEHOLDER_LOCALE_EN',
	fr: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_PLACEHOLDER_LOCALE_FR',
	it: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_PLACEHOLDER_LOCALE_IT',
	pt: 'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_PLACEHOLDER_LOCALE_PT',
};
